import { websocketMessage } from 'actions/prospectMessage/prospectMessageActions';
import { convertToProspectMessage } from 'actions/prospectMessage/prospectMessageConverter';
import { ProspectMessageDto } from 'actions/prospectMessage/prospectMessageDtos';
import { setTwoWaySmsThunk } from 'actions/twoWaySms/twoWaySmsActions';
import { SmsMessageDto } from 'actions/twoWaySms/twoWaySmsDtos';
import { useAuth, useHasPremiumAccess } from 'hooks';
import { TwoWaySmsWebSocketsMessage } from 'model/WebSockets';
import { FunctionComponent, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useMessagesChannelMarketplace } from './MessagesChannelMarketplaceContext';
import { websocketLog } from './websocketLog';
import { useActionCableChannel } from './useActionCableChannel';

const TwoWaySmsWebSockets: FunctionComponent = () => {
    const auth = useAuth();
    const dispatch = useDispatch();
    const hasTwoWaySmsAccess = useHasPremiumAccess('two_way_sms');
    const { effectiveMarketplaceId } = useMessagesChannelMarketplace();

    const onReceived = useCallback(
        (message: TwoWaySmsWebSocketsMessage) => {
            websocketLog('message', 'TwoWaySmsWebSockets', { messageType: message.message_type });

            if (message.message_type === 'SmsMessage' && message.message) {
                dispatch(
                    setTwoWaySmsThunk(message.message as SmsMessageDto, message.unread_count, effectiveMarketplaceId)
                );
            }

            if (message.message_type === 'ProspectMessage' && message.message) {
                dispatch(
                    websocketMessage(
                        convertToProspectMessage(message.message as ProspectMessageDto),
                        message.unread_count,
                        effectiveMarketplaceId
                    )
                );
            }
        },
        [dispatch, effectiveMarketplaceId]
    );

    useActionCableChannel<TwoWaySmsWebSocketsMessage>({
        channel: 'MessagesChannel',
        params: { marketplace_id: effectiveMarketplaceId },
        enabled: Boolean(auth.signedIn && hasTwoWaySmsAccess && effectiveMarketplaceId),
        onReceived,
        subscriptionDeps: [effectiveMarketplaceId, hasTwoWaySmsAccess],
        logLabel: 'TwoWaySmsWebSockets'
    });

    return null;
};

export default TwoWaySmsWebSockets;
